<div class="company-page-container">
  <div class="company-card" *ngFor="let company of companies">
    <company-block-card [title]="company.businessName" [isMarginBottom]="true" [isTitleTranslatable]="false">
      <div card-actions class="d-flex align-items-center">
        <div
          class="header-container__actions"
          *ngIf="canDeleteCompany(company)"
          (click)="$event.stopPropagation(); onShowDeleteConfirm(company)"
        >
          <img src="assets/icons/icon_trash.svg" />
          <span *ngIf="!(isTablet$ | async)">{{ "BUTTON.DELETE" | translate }}</span>
        </div>
        <div class="header-container__actions" (click)="redirectToCompanyView(company.id)">
          <img src="assets/icons/eye_gray.svg" />
          <span *ngIf="!(isTablet$ | async)">{{ "BUTTON.VIEW" | translate }}</span>
        </div>
      </div>

      <ng-container card-body>
        <div class="info-container">
          <div class="info-container__logo" *ngIf="!!company?.logoUri">
            <img src="{{ company.logoUri }}" />
          </div>

          <div class="info-container__logo-upload" *ngIf="!company?.logoUri && !isPhotoIdBusinessType(company?.businessType)">
            <document-upload-logo
              [id]="'company-logo-' + company.id"
              [isLoading]="isLoadingLogo(company.id)"
              (upload)="uploadCompanyLogo($event, company.id)"
            ></document-upload-logo>
          </div>

          <div
            class="info-container__logo info-container__logo--person-icon"
            *ngIf="!company?.logoUri && isPhotoIdBusinessType(company?.businessType)"
          >
            <i class="fa fa-user" aria-hidden="true"></i>
          </div>

          <div class="w-100">
            <div class="info-container__item">
              <span class="label">{{ "LABELS.BUSINESS_TYPE" | translate }}</span>
              <span class="value" *ngIf="company?.businessType">
                {{ "BUSINESS_TYPE." + enumCompanyBusinessType[company?.businessType] | translate }}
              </span>
            </div>
            <div class="info-container__item">
              <span class="label">{{ "LABELS.BUSINESS_ID_NUMBER" | translate }}</span>

              <span
                class="value"
                [ngClass]="{ 'cbp-pending': isCbpRegistrationPending(company) }"
                *ngIf="!!company?.identifierQualifier || isCbpRegistrationPending(company)"
              >
                {{
                  isCompanyWithCbpAssignedNumberRequested(company)
                    ? isCbpRegistrationCompleted(company)
                      ? ("LABELS.ASSIGNED_CBP_NUMBER" | translate) + ": "
                      : ""
                    : (company?.identifierQualifier | identifierQualifier | translate)
                }}
                {{ getCompanyIdentifier(company) }}
              </span>

              <span class="value text-error" *ngIf="!company?.identifierQualifier && isCbpRegistrationRejected(company)">
                {{ "LABELS.REGISTRATION_REJECTED" | translate }}
              </span>
            </div>
            <div class="info-container__item">
              <span class="label">{{ "LABELS.BUSINESS_ADDRESS" | translate }}</span>
              <span class="value">{{ getCompanyAddressLine(company) }}</span>
            </div>
            <div class="info-container__item" *ngIf="!isHasOnboardingRedesign">
              <span class="label">{{ "LABELS.SHIPPING_PROFILE_DEFINITIONS" | translate }}</span>
              <span class="value">
                {{ "LABELS.SHIPPING_PROFILE_DEFINITIONS_TYPES." + enumShippingRole[company?.shippingRole] | translate }}
              </span>
            </div>
            <ng-container>
              <div
                class="info-container__item"
                *ngIf="
                  ((!company.isUnitedStates && company.isAllowedForCustoms) || company.isUnitedStates) &&
                  companiesLastDependency[company?.id]?.state
                "
              >
                <span class="label">{{ "LABELS.COMPANY_REGISTRATION_STATUS_LABEL" | translate }}</span>
                <span
                  class="value"
                  *ngIf="!!companiesLastDependency[company?.id]"
                  [ngStyle]="{ color: registrationCompanyTextColor(company?.id) }"
                >
                  {{ this.registrationCompanyText(company?.id) | translate }}
                </span>
              </div>
            </ng-container>
            <ng-container>
              <div class="info-container__item info-container__item-centered">
                <span class="label">{{ "LABELS.COMPANY_MEMBERS_LABEL" | translate }}</span>
                <div class="value">
                  <app-gravatar
                    *ngFor="let organizationMember of getOrganizationCompanyMembers(company.id)"
                    [acronymText]="organizationMember.user.firstName.charAt(0) + organizationMember.user.lastName.charAt(0)"
                    [isNotificationOn]="organizationMember.role === enumOrganizationMemberRole.ADMIN"
                  />
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </company-block-card>
  </div>

  <div class="company-card company-card-add pb-2 pt-2" *ngIf="isOrganizationAdmin">
    <div class="add-company-container" (click)="redirectToCreateCompany()">
      <div>
        <img class="add-company-container__add-icon" alt="add" src="/assets/icons/icon_click_add.svg" />
        <span class="add-company-container__text">{{ "LABELS.IOR_ADD_ANOTHER_PROFILE" | translate }}</span>
      </div>
      <img src="assets/icons/icon_chevron_right.svg" class="add-company-container__chev-icon" />
    </div>
  </div>
</div>

<delete-company-modal
  [isOpen]="isDeleteModalOpen"
  [company]="companyToDelete"
  [isDeleting]="isDeleting"
  [headerKey]="'DELETE_IOR_PROFILE'"
  [descriptionKey]="'DELETE_IOR_DESCRIPTION'"
  [confirmButtonKey]="'BUTTON.DELETE_IOR'"
  [fallbackNameKey]="'LABELS.IMPORTER_OF_RECORD'"
  (confirmed)="onDeleteCompany()"
  (cancelled)="onHideDeleteConfirm()"
></delete-company-modal>
